import React from "react";
import { HeadFC, Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { Container, Button } from "react-bootstrap";
import DefaultLayout from "../../layouts/default/default.layout";
import { stringJoin, PromoLink } from "../../../utils/functions";
import DefaultTitle from "../../layouts/default-title";

import * as PromoStyles from "./promo.module.scss";

type PromoTemplateProps = NonNullable<Queries.PromotionFrontmatterFragment>;

export const PromotionDetailTemplate: React.FC<React.PropsWithChildren<PromoTemplateProps>> = ({ frontmatter, children }) => {
    const { name, archived } = frontmatter!;

    if (archived) {
        return (
            <DefaultLayout>
                <Container className="text-center pt-5 mt-5 text-labatt">
                    <div style={{ minHeight: "70vh" }}>
                        <h1 className="display-3">This promotion is no longer available</h1>
                        <h2 className="pt-2 pb-2 text-white">View our promotions page for a full list of active promotions.</h2>
                        <Link to={PromoLink()}>
                            <Button className="labattButton text-uppercase">View Promotions</Button>
                        </Link>
                    </div>
                </Container>
            </DefaultLayout>
        );
    }

    const imageData = frontmatter?.image?.childImageSharp?.gatsbyImageData ? getImage(frontmatter.image.childImageSharp.gatsbyImageData) : null;

    return (
        <DefaultLayout>
            <Container className={PromoStyles.container}>
                <h1 className="display-1 text-center text-uppercase mt-5 pt-5 py-3">{name}</h1>
                <div className={PromoStyles.imageContainer}>
                    {imageData && <GatsbyImage image={imageData} alt={name || "Promotion Image"} className={stringJoin(PromoStyles.promoImage, 'd-block mx-auto"')} />}
                </div>
                <div className={PromoStyles.labattPromo}>{children}</div>
            </Container>
        </DefaultLayout>
    );
};

export const PromotionDetailHead: HeadFC<PromoTemplateProps> = ({ data, location }) => {
    return (
        <DefaultTitle
            title={data.frontmatter?.name ?? undefined}
            metaDescription={data.frontmatter?.meta_description ?? undefined}
            location={location}
            metaImagePath={data.frontmatter?.image?.publicURL ?? undefined}
        />
    );
};
